import React from 'react';
import { IconProps } from '../../DefaultIcon';

export function GeoIcon({ className }: IconProps) {
  return (
    <svg
      width="84"
      height="84"
      viewBox="0 0 84 84"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1147_2316)">
        <path
          d="M84 42C84 65.1978 65.1978 84 42 84C18.8022 84 0 65.1978 0 42C0 18.8022 18.8022 0 42 0C65.1978 0 84 18.8022 84 42Z"
          fill="#E8ECF7"
        />
        <path
          d="M25.6116 72.8964C34.0218 74.8528 35.5971 56.381 26.755 56.9146C19.539 57.3465 25.2305 49.6986 17.9129 51.8837C17.049 52.1378 16.2359 52.2648 15.4991 52.3156C9.04537 52.5951 7.16515 45.2521 13.9746 43.3973C16.2359 42.7621 22.2323 41.0089 23.7314 34.606C25.3067 27.822 16.2359 25.8147 18.0653 21.5715C20.0472 16.9218 36.2323 23.0706 36.2323 15.7022C36.2323 11.6623 31.4301 12.7803 28.2033 11.9926C24.3412 11.0271 22.588 8.02889 21.9274 5.10693C8.86751 12.2213 0 26.0688 0 41.9999C0 56.381 7.24138 69.0597 18.2686 76.6314C19.9201 74.3193 22.3593 72.1596 25.637 72.8964"
          fill="#00C4B3"
        />
        <path
          d="M62.9108 61.3613C61.183 61.9711 57.448 66.9765 59.5569 68.0437C61.9198 69.2379 62.4534 68.1199 64.4353 66.2397C66.4171 64.3595 68.7039 65.2234 68.4498 63.394C68.0687 60.8023 64.6639 60.7261 62.9108 61.3359"
          fill="#00C4B3"
        />
        <path
          d="M73.9381 14.7366C73.1759 15.5497 72.4136 16.4898 71.6006 17.5823C69.5933 20.3518 65.4009 20.4789 63.0888 15.9562C62.1995 14.203 60.9545 12.8818 59.5062 11.9925C54.7803 9.09595 48.047 10.9253 45.6587 19.3101C45.5824 19.5388 45.5316 19.742 45.4808 19.9707C44.6423 23.7312 45.7857 27.9743 52.214 28.4571C60.5479 29.0669 56.2539 37.3754 51.1977 35.5206C46.1668 33.6658 43.626 31.811 39.459 35.1395C35.292 38.4426 36.0035 44.0832 41.0089 44.8963C44.5661 45.4807 46.3701 50.4607 44.998 52.036C43.0162 53.7892 40.2467 60.7511 43.9563 64.8673C47.6659 68.9834 50.4862 66.0869 51.528 63.6731C52.5697 61.2593 52.6205 59.6586 54.5262 56.4571C55.949 54.0687 60.8783 53.0016 60.8783 53.0016C60.8783 53.0016 64.9182 51.5533 62.1233 44.0324C59.3029 36.5116 69.1106 37.7566 71.2703 42.8382C73.0743 47.0814 68.7803 54.0433 76.3773 52.7983C79.5026 52.2901 80.8492 53.6876 82.018 54.831C83.3138 50.791 84.0253 46.497 84.0253 42.0252C84.0253 31.6332 80.2394 22.105 73.9636 14.7874"
          fill="#00C4B3"
        />
      </g>
      <defs>
        <clipPath id="clip0_1147_2316">
          <rect width="84" height="84" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
